import select2 from 'select2';

select2();

$(document).ready(() => {
  $('.select-custom').select2({
    minimumResultsForSearch: Infinity, // remove search bar
  });
});
